import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=545fc638&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=545fc638&prod&lang=scss"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=545fc638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fc638",
  null
  
)

/* custom blocks */
import block0 from "./sidebar.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports